import { createSlice, createSelector } from '@reduxjs/toolkit';

export const callParkSlice = createSlice({
  name: 'callPark',
  initialState: {
    loading: true,
    parkSpots: {},
    error: null,
  },
  reducers: {
    setParkSpots: (state, action) => {
      state.loading = false;
      // Convert array to object with queue_name as key
      state.parkSpots = action.payload.reduce((acc, park) => {
        acc[park.queue_name] = {
          ...park,
          parkedCalls: [] // Initialize empty parked calls array
        };
        return acc;
      }, {});
    },

    updateParkedCall: (state, action) => {
      const { parkSpot, callData, remove } = action.payload;
      const spot = state.parkSpots[parkSpot];

      if (spot) {
        if (remove) {
          spot.parkedCalls = spot.parkedCalls.filter(
            call => call.orig_callid !== callData.orig_callid
          );
        } else {
          // Add or update parked call
          const existingCallIndex = spot.parkedCalls.findIndex(
            call => call.orig_callid === callData.orig_callid
          );

          if (existingCallIndex >= 0) {
            spot.parkedCalls[existingCallIndex] = callData;
          } else {
            spot.parkedCalls.push(callData);
          }
        }
      }
    },

  },
});

export const { setParkSpots, updateParkedCall } = callParkSlice.actions;
//Selectors
export const selectCallParkState = state => state.callPark;

export const selectParkSpots = createSelector(
  [selectCallParkState],
  (callParkState) => Object.values(callParkState.parkSpots)
    .sort((a, b) => b.parkedCalls.length - a.parkedCalls.length)
);

export const selectTotalParkedCalls = createSelector(
  [selectCallParkState],
  (callParkState) => {
    return Object.values(callParkState.parkSpots)
      .reduce((total, spot) => total + spot.parkedCalls.length, 0);
  }
);

export const selectLoading = createSelector(
  [selectCallParkState],
  (callParkState) => callParkState.loading
);

export const selectError = createSelector(
  [selectCallParkState],
  (callParkState) => callParkState.error
);
export default callParkSlice.reducer;
